import React from 'react';
import { DataProviderInstance } from '../../../../api/DataProvider';
import { SendWhatsAppMessage } from '../../../../api/WhatsappAPI';
import MessagesTemplate from '../../../../consts/MessagesTemplate';
import WavingHandOutlinedIcon from '@mui/icons-material/WavingHandOutlined';
import PatientItem from '../shared/PatientItem';
import { ContactActions } from '../shared/IconAction';
import useSentFlag from '../../hooks/useSentFlag';
import RelationshipSection from './RelationshipSection';
import { procedureLabels } from '../../../appointments/v2/utils/appointmentUtils';

function FirstVisitItem({ item }) {
  const { CompanyConfig, GetPatientById, GetResourceById } = DataProviderInstance();
  const templates = MessagesTemplate.getTemplates(CompanyConfig);
  const [sent, markSent] = useSentFlag(`firstVisitMsgSent-v2-${item.id}`);

  // item.patient, .resource e .procedure são IDs — resolver via DataProvider
  const patient = GetPatientById(item.patient);
  const resourceName = GetResourceById(item.resource)?.Label || '';
  const procedureName = procedureLabels(item, CompanyConfig?.Procedures);
  const patientName = patient?.name || 'Paciente';
  const patientPhone = patient?.phone || '';
  const hasPhone = patientPhone.length >= 8;

  function handleWhatsApp() {
    let message = templates.FirstAppointmentFollowup || '';
    if (!message) return;

    message = message.replaceAll('{name}', patientName.split(' ')[0]);
    message = message.replaceAll('{company_name}', CompanyConfig?.Name || '');
    message = message.replaceAll('{procedure}', procedureName);
    message = message.replaceAll('{doctor_name}', resourceName);

    SendWhatsAppMessage(patientPhone, MessagesTemplate.ConvertToWhatsAppText(message), patient?.countryCode);
    markSent();
  }

  return (
    <PatientItem
      name={patientName}
      patientId={item.patient}
      tone="green"
      sent={sent}
      meta={['Primeira consulta ontem', procedureName].filter(Boolean).join(' · ')}
      actions={hasPhone && <ContactActions whatsappTitle="Perguntar como foi" onWhatsApp={handleWhatsApp} phone={patientPhone} />}
    />
  );
}

function FirstVisitSection({ list }) {
  return (
    <RelationshipSection
      icon={<WavingHandOutlinedIcon style={{ fontSize: 15 }} />}
      tone="green"
      title="Pós primeira consulta"
      hint="Pergunte como o paciente está"
      count={list.length}
    >
      {list.map((item, index) => <FirstVisitItem key={item.id || index} item={item} />)}
    </RelationshipSection>
  );
}

export default FirstVisitSection;
